const CODE_128_PATTERNS = [
    "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
    "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
    "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
    "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
    "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
    "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
    "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
    "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
    "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
    "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
    "114131", "311141", "411131", "211412", "211214", "211232", "2331112",
];

const START_CODE_B = 104;
const STOP_CODE = 106;

export const canEncodeCode128B = (value) => /^[\x20-\x7E]+$/.test(String(value || ""));

export const getCode128BSymbols = (value) => {
    const text = String(value || "").trim();
    if (!text) return [];
    if (!canEncodeCode128B(text)) {
        throw new Error("Barcode can only contain standard printable characters.");
    }

    const dataCodes = [...text].map((char) => char.charCodeAt(0) - 32);
    const checksum = (START_CODE_B + dataCodes.reduce((sum, code, index) => sum + code * (index + 1), 0)) % 103;
    return [START_CODE_B, ...dataCodes, checksum, STOP_CODE];
};

export const getCode128SvgMetrics = (value, options = {}) => {
    const moduleWidth = options.moduleWidth || 2;
    const barHeight = options.barHeight || 72;
    const textHeight = options.textHeight || 24;
    const quietZone = options.quietZone || 10;
    const symbols = getCode128BSymbols(value);
    const moduleCount = symbols.reduce((total, code) => {
        return total + CODE_128_PATTERNS[code].split("").reduce((sum, digit) => sum + Number(digit), 0);
    }, quietZone * 2);

    return {
        symbols,
        moduleWidth,
        barHeight,
        textHeight,
        quietZone,
        width: moduleCount * moduleWidth,
        height: barHeight + textHeight,
    };
};

export const renderCode128SvgBars = (value, options = {}) => {
    const metrics = getCode128SvgMetrics(value, options);
    let x = metrics.quietZone * metrics.moduleWidth;
    const bars = [];

    metrics.symbols.forEach((code, symbolIndex) => {
        const pattern = CODE_128_PATTERNS[code];
        [...pattern].forEach((digit, patternIndex) => {
            const width = Number(digit) * metrics.moduleWidth;
            if (patternIndex % 2 === 0) {
                bars.push({ x, y: 0, width, height: metrics.barHeight, key: `${symbolIndex}-${patternIndex}` });
            }
            x += width;
        });
    });

    return { ...metrics, bars };
};
